import React from 'react';

import type { WithClassNameProp } from '@vlabs/uikit/types';
import classNames from 'classnames';

import './LegacyHeight.sass';
import './PageSidePanel.sass';
import { useSidePanel } from '../side-panel';
import type { WithLegacyProp } from './legacyProp';

interface PageSidePanelProps extends React.PropsWithChildren, WithClassNameProp, WithLegacyProp {
  /** На узких экранах панель открывается поверх контента (fixed) или остаётся в ряду.
   * По умолчанию — поверх, как у фильтров. */
  overlay?: boolean;
}

function PageSidePanel({
  children,
  legacy = false,
  overlay = true,
  className = undefined,
}: PageSidePanelProps): React.JSX.Element {
  const { isOpen = false } = useSidePanel();

  return (
    <div
      className={classNames(
        'PageSidePanel',
        {
          PageSidePanel_isOpen: isOpen,
          PageSidePanel_noOverlay: !overlay,
          'legacy-height': legacy,
        },
        className,
      )}
    >
      {children}
    </div>
  );
}

export { PageSidePanel };
